import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  packageNumber: {
    defaultMessage: 'Package {number}',
    description: 'Label for each package card. {number} is the package number starting from 1',
    id: 'If0DTT',
  },
  packageNumberWithName: {
    defaultMessage: 'Package {number} - {name}',
    description:
      'Label for each package card when a custom package type is selected. {number} is the package number starting from 1, {name} is the custom package type name',
    id: '0u9+Zg',
  },
  noItemsAssigned: {
    defaultMessage: 'No items assigned',
    description: 'Message shown in empty package drop zone when no items have been assigned yet',
    id: 'Shpgyy',
  },
  dragItemsHere: {
    defaultMessage: 'Drag & drop items to assign',
    description: 'Hint text shown in empty package drop zone explaining how to add items',
    id: 'PoMH7L',
  },
  removePackageLabel: {
    defaultMessage: 'Remove package',
    description: 'Aria label for the button to remove a package',
    id: 'Z5p0eH',
  },
  copyPackageLabel: {
    defaultMessage: 'Duplicate package',
    description: 'Aria label for the button to duplicate a package',
    id: 'vgCgHB',
  },
  packageIconAlt: {
    defaultMessage: 'Package Icon',
    description: 'Alt text for the package icon image',
    id: 'iZGNsS',
  },
  removeItemLabel: {
    defaultMessage: 'Remove item',
    description: 'Aria label for button to remove an item from a package',
    id: 'vt3SJP',
  },
  removePackageDisabledTooltip: {
    defaultMessage: 'Remove items before deleting this package',
    description: 'Tooltip message shown when the remove package button is disabled because it has items assigned',
    id: 'YiEhJ0',
  },
});
